import {StylesConfig} from 'react-select';

export const selectStyle: StylesConfig = {
  input: (provided) => ({
    ...provided,
    cursor: 'text',
  }),
};
